import { z } from "zod";

import HomeComponent from "@/components/dashboard/home/home";
import useAuthStore from "@/store/auth";
import { createFileRoute, redirect, useNavigate } from "@tanstack/react-router";

const routeParamsSchema = z.object({
	contractCode: z.string().optional(),
	contractId: z.string().optional()
});
export const Route = createFileRoute("/buyer/home")({
	validateSearch: routeParamsSchema,
	loader: () => {
		const user = useAuthStore.getState().user;
		if (!user) {
			throw redirect({
				to: "/sign-in"
			});
		}
		if (user.userType !== "BUYER") {
			throw redirect({
				to: "/vendor/home"
			});
		}
	},
	component: RouteComponent
});

function RouteComponent() {
	const navigate = useNavigate();
	const user = useAuthStore(state => state.user);

	if (!user) {
		return navigate({ to: "/sign-in" });
	}

	return <HomeComponent />;
}
